import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

const MAP_COORDS = "45.67897,12.40132";
const MAP_EMBED_SRC = `https://www.openstreetmap.org/export/embed.html?bbox=12.3990%2C45.6775%2C12.4045%2C45.6805&layer=mapnik&marker=${MAP_COORDS.replace(",", "%2C")}`;
const MAP_DIRECTIONS_HREF = `https://www.google.com/maps/search/?api=1&query=${MAP_COORDS.replace(",", "%2C")}`;

export const Contact = ({ t }) => (
  <section id="contatti" data-testid="contact-section" className="py-24 lg:py-32 bg-[#1C3829] text-[#F7F5F0]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-80px" }}>
        <p className="text-xs uppercase tracking-[0.35em] text-[#C29B62]">{t.contact.overline}</p>
        <h2 className="mt-4 text-4xl sm:text-5xl font-light tracking-tight">{t.contact.title}</h2>
        <p className="mt-6 text-base text-[#F7F5F0]/70 font-light max-w-xl">{t.contact.garden}</p>
      </motion.div>

      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-stretch"
      >
        <div className="grid grid-cols-1 gap-10 content-start">
          <div data-testid="contact-address" className="border-t border-[#C29B62]/30 pt-6">
            <MapPin className="w-5 h-5 text-[#C29B62]" />
            <p className="mt-4 text-sm text-[#F7F5F0]/80 font-light leading-relaxed">{t.contact.address}</p>
          </div>
          <div data-testid="contact-email" className="border-t border-[#C29B62]/30 pt-6">
            <Mail className="w-5 h-5 text-[#C29B62]" />
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#F7F5F0]/50">{t.contact.emailLabel}</p>
            <a href="mailto:sales@villanavagero.com" data-testid="contact-email-link" className="mt-2 block text-lg font-light hover:text-[#C29B62] transition-colors">
              sales@villanavagero.com
            </a>
          </div>
          <div data-testid="contact-phone" className="border-t border-[#C29B62]/30 pt-6">
            <Phone className="w-5 h-5 text-[#C29B62]" />
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#F7F5F0]/50">{t.contact.phoneLabel}</p>
            <a href="tel:+393298667416" data-testid="contact-phone-link" className="mt-2 block text-lg font-light hover:text-[#C29B62] transition-colors">
              +39 329 866 7416
            </a>
          </div>
        </div>

        <div data-testid="contact-map" className="border border-[#C29B62]/30 min-h-[22rem] flex flex-col">
          <iframe
            title="Villa Navagero · Via Grande 2, Rovarè"
            src={MAP_EMBED_SRC}
            className="w-full flex-1 min-h-[20rem] grayscale-[35%] contrast-[1.05]"
            loading="lazy"
          />
          <a
            data-testid="contact-map-directions"
            href={MAP_DIRECTIONS_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center text-xs uppercase tracking-[0.25em] py-4 bg-[#C29B62] text-[#101f17] hover:bg-[#F7F5F0] transition-colors"
          >
            {t.contact.directions}
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
